var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M12.8926 9.80273H18.3471"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M15.438 6.36523L18.876 9.80325L15.438 13.2413"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M7.80176 9.80273H2.34721"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M5.25635 6.36523L1.81833 9.80325L5.25635 13.2413"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M9.2561 2.72852V17.274"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M11.438 2.72852V17.274"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluid);
export default __webpack_public_path__ + "static/media/fluid.0362f7510633b47701be1438e344144b.svg";
export { ForwardRef as ReactComponent };